import { BannerSchema } from '@/components/Banner/style/Banner.styles';

export const bannerStyles: BannerSchema = {
  bannerBoxProps: {
    background: 'none',
    bgGradient: 'linear-gradient(180deg, #007DC6 0%, #00578A 100%)',
    borderRadius: 'md',
    border: 'none',
    gap: '3',
  },
  depositIconProps: {
    color: 'beta.500',
    boxSize: '9',
  },
};
